export const Errors = {
    FORMAT_ERROR: 1,
    RANGE_ERROR: 2,
};
